
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/career-competency",
      function () {
        return require("private-next-pages/career-competency/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/career-competency"])
      });
    }
  